<template>
  <router-view></router-view>
</template>

<script>
export default {
    name: "ps-wrapper-ba"
};
</script>

<style>
</style>